import { ActivityLog } from "./ActivityLog";

export default ActivityLog;
